module.exports = __webpack_public_path__ + "static/Tastea4-be59a28c0fc4498e399acab998c0a8e7.jpg";